var lx = lx || {};
lx.article = lx.article || {};

lx.bookmark = {
    add: function (pEty, pRec, pBtnType, pThis, pReaction){
        lx.load.add();
        apex.server.process("handleBookmark", {
            x01: "ADD",
            x02: pEty,
            x03: pRec,
            x04: pBtnType,
			x05: pReaction
        }, {
            dataType: 'json',
            success: function (d){
                lx.load.remove();
                if (d.success) {
                    /*$(pThis).closest(".feed-post,.lxArt").addClass("bookmarked");*/
                    $(pThis).replaceWith(d.btn);
                } else {
                    lx.info.error(d.err);
                }
            }
        }
        );
    },
    remove: function (pEty, pRec, pBtnType, pThis, pReaction){
        lx.load.add();
        apex.server.process("handleBookmark", {
            x01: "DEL",
            x02: pEty,
            x03: pRec,
            x04: pBtnType,
			x05: pReaction
        }, {
            dataType: 'json',
            success: function (d){
                lx.load.remove();
                if (d.success) {
                    /*$(pThis).closest(".feed-post,.lxArt").removeClass("bookmarked");*/
                    $(pThis).replaceWith(d.btn);
                } else {
                    lx.info.error(d.err);
                }
            }
        }
        );
    }
}

/* Publish */
lx.article.publish = function (pEty, pRec, pType) {
    lx.load.add();
    apex.server.process("publishArticle", {
        x01: pEty,
        x02: pRec,
        x03: pType
    }, {
            dataType: 'text',
            success: function (d) {
                lx.load.remove();
                location.reload();
            }
        });
};

lx.article.qNewsForm = function (pStep, pId, pEtyId, pThis, pShowNews) {
    lx.load.add();
    apex.server.process("qNewsForm", {
        x01: pStep,
        x02: pId,
        x03: pEtyId
    }, {
            dataType: "html",
            success: function (d) {
                lx.load.remove();
                $(".qNews").replaceWith(d);
                $(".qUpSwitch > div > div.highlight").removeClass("highlight");
                $(".qUpSwitch > div > div > svg").css('color', '#848484');
                $(pThis).addClass("highlight");
                $(pThis).find('svg').css('color', '#f2f2f2');
                if (pEtyId == 2) {
                    $("#qEvent6").datetimepicker({ dateFormat: translation.date_format, timeFormat: translation.time_format });
                    $("#qEvent7").datetimepicker({ dateFormat: translation.date_format, timeFormat: translation.time_format });
                }
            }
        });
};


lx.article.console = function (pId, pChecked, pEty, pPath, pEdit, pPage, pSearch) {
        apex.server.process('GalleryManagementConsole', {
            x01: pId,
            x02: pChecked,
            x03: pEty,
            x04: pPath,
            x05: pEdit,
            x06: pPage,
            x07: pSearch
        }, {
            dataType: "html",
            success: function(r) {
                if (r) {
                    $("#uiGallConsole").html(r);
                }
            }
        });
};

lx.article.enableEdit = function(pName) {
        $('#uiDocName[name="' + pName + '"]').editable('enable').css({
            'background-color': '#fff',
            'padding': '5px'
        });
    };

lx.article.getMoreRelatedArticles = function(pProfileId, pId, pEty, pStart, pThis, pRoadmapId) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getMoreNlrArticles",
            x01: pProfileId,
            x02: pId,
            x03: pEty,
            x04: pStart,
            x05: pRoadmapId
        },
        success: function(d) {
            $(pThis).replaceWith(d);
        }
    });
};

lx.article.getArticleText = function (pEntity, pId, pThis) {
    apex.server.process('getArticleText', {
        x01: pEntity,
        x02: pId
    }, {
        dataType: "html",
        success: function(d) {
            $(pThis).closest(".feed-article_text,.feed-richtext").html(d);
        }
    });
};

lx.article.openVideo = function (pThis, pJumpTo){
    var lHtml, lType, lUrl, lVideoId;
    var $lThis = ($(pThis).hasClass('feed-video') ? $(pThis) : $(pThis).closest('.feed-content').next('.feed-video'));
    console.log($(pThis).closest('.feed-content'));
    lType = $lThis.attr("data-type");
    lUrl = $lThis.attr("data-url");
    lVideoId = $lThis.attr("data-videoid");
    //console.log($(pThis));
    //console.log(lType == 'YT');
    if (lType == 'YT') {
            lHtml = '<iframe width="100%" height="315" src="https://www.youtube.com/embed/'+ lVideoId + '?autoplay=1'+(pJumpTo ? '&start='+pJumpTo : '') +'&origin=https://linxpot.com'+
                    '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            //console.log(lHtml);
    }
    $lThis.html(lHtml);
}

lx.article.toggle_region = function (idShow, idHide, pCnt, pSelect, pNotSelect) {
	var e1 = document.getElementById(idShow);
	var e2 = document.getElementById(idHide);
	if(e1.style.display == 'none') {
		e1.style.display = '';
		$("#"+pSelect).addClass("ArtBtnSelected");
		$("#"+pSelect+" > i").addClass("ArtBtnIconSel");
		$("#"+pSelect+" > i").removeClass("far fa-square");
		$("#"+pSelect+" > i").addClass("far fa-check-square");
		$("#"+pSelect+" > span").css("color", "#ffffff");
		$("#"+pSelect).removeClass("artButton");
		if (pCnt == 0) {
	      e2.style.display = 'none';
		  $("#"+pNotSelect).removeClass("ArtBtnSelected");
		  $("#"+pNotSelect+" > i").removeClass("ArtBtnIconSel");
		  $("#"+pNotSelect+" > i").removeClass("far fa-check-square");
		  $("#"+pNotSelect+" > i").addClass("far fa-square");
		  $("#"+pNotSelect+" > span").css("color", "#333333");
		  $("#"+pNotSelect).addClass("artButton");
		}
	}
    else {
		e1.style.display = 'none';
		$("#"+pSelect).removeClass("ArtBtnSelected");
		$("#"+pSelect+" > i").removeClass("ArtBtnIconSel");
		$("#"+pSelect+" > i").removeClass("far fa-check-square");
		$("#"+pSelect+" > i").addClass("far fa-square");
		$("#"+pSelect+" > span").css("color", "#333333");
		$("#"+pSelect).addClass("artButton");
	}
};

lx.article.toggle_regions = function (id, BtnId) {
	var e = document.getElementById(id);
	if(e.style.display == 'none'){
		e.style.display = '';
		$("#"+BtnId).removeClass("artButton");
		$("#"+BtnId+" > i").removeClass("far fa-square");
		$("#"+BtnId+" > i").addClass("far fa-check-square");
		$("#"+BtnId+" > i").addClass("ArtBtnIconSel");
		$("#"+BtnId).addClass("ArtBtnSelected");
		$("#"+BtnId+" > span").css("color", "#ffffff");
		if (BtnId == 'ticketBtn') {
		  apex.item("P18_CHARGE").setValue("Y");
		} 
		
	}
	else {
		e.style.display = 'none';
		$("#"+BtnId).removeClass("ArtBtnSelected");
		$("#"+BtnId+" > i").removeClass("ArtBtnIconSel");
		$("#"+BtnId+" > i").removeClass("far fa-check-square");
		$("#"+BtnId+" > i").addClass("far fa-square");
		$("#"+BtnId).addClass("artButton");
		$("#"+BtnId+" > span").css("color", "#333333");
		if (BtnId == 'ticketBtn') {
		  apex.item("P18_CHARGE").setValue("N");
		} 
	}
};

lx.article.generateButtons = function (pId, pEtyId) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=generateButtons",
                x01: pId,
                x02: pEtyId
            },
            success: function (d) {
                $('#artButtons').html(d);
            }
        });
    }    
	
lx.article.generateButton = function (pId, pEtyId) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=generateButton",
                x01: pId,
                x02: pEtyId
            },
            success: function (d) {
				if (d !== null && d !== '') {$('#addVideo').show();
				} else {
					$('#addVideo').hide();
				}
               // $('#addVideo').html(d);
            }
        });
   }  	

// TODO cleanup after we ditch the old app
var publishArticle = lx.article.publish;
var qNewsForm = lx.article.qNewsForm;
var getMoreRelatedArticles = lx.article.getMoreRelatedArticles;